import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { colors } from '../theme';
import { KYIV_ZONE } from '../kyivTime';

const useStyles = makeStyles({
  box: {
    textAlign: 'right',
    lineHeight: 1.15,
  },
  time: {
    color: colors.text,
    fontSize: '22px',
    fontWeight: 700,
    fontVariantNumeric: 'tabular-nums',
  },
  date: {
    color: colors.textDim,
    fontSize: '11px',
    marginTop: 2,
  },
  // Под логотипом на зелёном фоне: время и дата в одну строку, по центру и белым.
  onBrand: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    flexWrap: 'wrap',
    columnGap: 8,
    marginTop: 8,
    '& $time, & $date': { color: '#fff' },
    '& $time': { fontSize: '16px' },
    '& $date': { fontSize: '12px', marginTop: 0, whiteSpace: 'nowrap' },
  },
  // «по Киеву» отдельной строкой под временем и датой.
  zone: {
    flexBasis: '100%',
    textAlign: 'center',
    color: 'rgba(255, 255, 255, 0.75)',
    fontSize: '10px',
    marginTop: 2,
  },
});

const TICK_MS = 5 * 1000;

// Киевское время в боковой панели: по нему считаются расписание и тихие часы, где бы ни был
// открыт экран.
function SidebarClock({ onBrand = false }) {
  const classes = useStyles();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), TICK_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={onBrand ? `${classes.box} ${classes.onBrand}` : classes.box} data-testid="sidebar-clock">
      <div className={classes.time}>
        {now.toLocaleTimeString('uk-UA', { timeZone: KYIV_ZONE, hour: '2-digit', minute: '2-digit' })}
      </div>
      <div className={classes.date}>
        {now.toLocaleDateString('ru-RU', { timeZone: KYIV_ZONE, weekday: 'short', day: 'numeric', month: 'long' })}
      </div>
      {onBrand && <div className={classes.zone}>по киевскому времени</div>}
    </div>
  );
}

export default SidebarClock;
